import ErrorIcon from '@lmt/unicorn-shared/app/icons/toast-error.svg?react';
import SuccessIcon from '@lmt/unicorn-shared/app/icons/toast-success.svg?react';
import InfoIcon from '@lmt/unicorn-shared/app/icons/toast-info.svg?react';
import clsx from 'clsx';
import React, { FC } from 'react';
import styles from './ToastIcon.module.scss';

interface Props {
  type: 'success' | 'warning' | 'error';
  className?: string;
}
export const ToastIcon: FC<Props> = (props) => {
  switch (props.type) {
    case 'error':
      return <ErrorIcon className={clsx(styles.errorIcon, props.className)} />;
    case 'success':
      return (
        <SuccessIcon className={clsx(styles.successIcon, props.className)} />
      );
    case 'warning':
      return <InfoIcon className={clsx(styles.warningIcon, props.className)} />;
    default:
      return undefined;
  }
};
